import React from 'react';

function Services() {
  return (
    <div>
      <h1>Our Services</h1>
      <ul>
        <li>
          <strong>Medical Device Solutions:</strong> Design and development of advanced micro-scale healthcare devices.
        </li>
        <li>
          <strong>Healthcare Consulting:</strong> Strategy and advisory for healthcare startups and organizations.
        </li>
        <li>
          <strong>Diagnostics and Lab Services:</strong> Cutting-edge diagnostic tools for early detection and monitoring.
        </li>
        <li>
          <strong>Research and Innovation:</strong> Collaborations in R&D to drive future-forward health solutions.
        </li>
      </ul>
    </div>
  );
}

export default Services;
